import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderPrayerLeaders from "../../../../src/content/prayforourleaders/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderPrayerLeaders,
  React
};